export default "__VITE_ASSET__52TwhIAF__"